// extracted by mini-css-extract-plugin
export default {"tip":"styles_tip__RPwrI","model":"styles_model__NWquJ","example":"styles_example__rcurq","img":"styles_img__Al-Wp","modalHeader":"styles_modalHeader__Cdv-h"};